<template>
  <div class="cardtable">
    <v-card class="mx-auto" light>
      <v-card-title>
        <span class="title font-weight-bold">Query</span>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-row>
            <v-col>
              <v-text-field label="Mobile" v-model="mobile" />
            </v-col>
            <v-col>
              <v-select
                v-model="selectedChannel"
                :items="channelItems"
                label="Channel"
              />
            </v-col>
            <v-col>
              <v-select
                v-model="selectedMethod"
                :items="methodItems"
                label="Method"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="selectedApplication"
                :items="applicationItems"
                item-value="appId"
                item-text="appName"
                label="Application"
              />
            </v-col>
            <v-col>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormattedBeginTime"
                    label="BeginTime"
                    persistent-hint
                    prepend-icon="$calendar"
                    v-bind="attrs"
                    @blur="beginTime = parseDate(dateFormattedBeginTime)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="beginTime"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormattedEndTime"
                    label="EndTime"
                    persistent-hint
                    prepend-icon="$calendar"
                    v-bind="attrs"
                    @blur="endTime = parseDate(dateFormattedEndTime)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endTime"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="successBtn" @click="search()">Query</v-btn>
        <v-btn class="successBtn" @click="exportxlsx()">Export</v-btn>
        <v-btn class="warningBtn" @click="reset()">Reset</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mx-auto my-5" light>
      <v-card-title>
        <span class="title font-weight-bold">Result</span>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Application</th>
                <th class="text-left">SendTime</th>
                <th class="text-left">Mobile</th>
                <th class="text-left">Channel</th>
                <th class="text-left">Method</th>
                <th class="text-left">Content</th>
                <th class="text-left">SendState</th>
                <th class="text-left">StatusReportState</th>
                <th class="text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.id">
                <td>{{ item.appName }}</td>
                <td>{{ item.sendTime }}</td>
                <td>{{ item.mobile }}</td>
                <td>{{ item.channel }}</td>
                <td>{{ item.method }}</td>
                <td>{{ formatSmsContent(item.content) }}</td>
                <td>{{ item.mtState }}</td>
                <td>{{ item.statusReportRtState }}</td>
                <td>
                  <div>
                    <v-tooltip>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="secondary"
                          fab
                          x-small
                          dark
                          v-bind="attrs"
                          v-on="on"
                          @click="viewSmsContent(item.content)"
                        >
                          <v-icon>$eye</v-icon>
                        </v-btn>
                      </template>
                      <span>View Sms Content</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div v-if="total == 0" class="empty">No data</div>
      </v-card-text>
      <v-card-actions>
        <v-pagination
          v-if="pages > 0"
          class="mx-auto pageinline"
          v-model="index"
          :length="pages"
          :total-visible="7"
        />
        <span class="totalrecord" v-if="total > 0"
          >Total Records: {{ this.total }}</span
        >
      </v-card-actions>
    </v-card>
    <core-loading ref="loading" />
    <core-confirm ref="confirm" @confirm="confirm" />
    <core-remind ref="remind" />
  </div>
</template>

<script>
import { callPost } from '@/scripts/api'
import CoreLoading from '@/components/core/loading.vue'
import CoreConfirm from '@/components/core/confirm.vue'
import CoreRemind from '@/components/core/remind.vue'
import format from 'date-fns/format'
import ExcelJS from 'exceljs'

export default {
  components: {
    CoreLoading,
    CoreConfirm,
    CoreRemind,
  },
  data: (x) => ({
    menu1: false,
    menu2: false,
    mobile: '',
    pageSize: 20,
    pages: 0,
    index: 1,
    list: [],
    total: 0,
    selectedChannel: '',
    channelItems: [
      {
        text: '全部',
        value: '',
      },
      {
        text: '拜耳中国',
        value: '拜耳中国',
      },
      {
        text: '拜耳医药',
        value: '拜耳医药',
      },
      {
        text: '拜耳环境科学',
        value: '拜耳环境科学',
      },
      {
        text: '拜耳作物科学',
        value: '拜耳作物科学',
      },
    ],
    selectedMethod: '',
    methodItems: [
      {
        text: '全部',
        value: '',
      },
      {
        text: '通知',
        value: '通知',
      },
      {
        text: '验证码',
        value: '验证码',
      },
      {
        text: '营销',
        value: '营销',
      },
    ],
    selectedApplication: '',
    applicationItems: [
      {
        appId: '',
        appName: '全部',
      },
    ],
    beginTime: new Date().toISOString().substr(0, 10),
    dateFormattedBeginTime: x.formatDate(
      new Date().toISOString().substr(0, 10)
    ),
    endTime: new Date().toISOString().substr(0, 10),
    dateFormattedEndTime: x.formatDate(new Date().toISOString().substr(0, 10)),
  }),
  mounted: function () {
    // this.search()
  },
  watch: {
    beginTime(val) {
      this.dateFormattedBeginTime = this.formatDate(val)
    },
    endTime(val) {
      this.dateFormattedEndTime = this.formatDate(val)
    },
    index() {
      this.search()
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
    parseDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    confirm() {},
    reset() {
      this.mobile = ''
      this.selectedChannel = ''
      this.selectedMethod = ''
      this.beginTime = new Date().toISOString().substr(0, 10)
      this.endTime = new Date().toISOString().substr(0, 10)
    },
    getapplication() {
      callPost(
        'v1.0/sms/application',
        {},
        this.$refs.loading,
        null,
        'Submitting request'
      ).then((result) => {
        this.applicationItems = result
        this.applicationItems.unshift({ appId: '', appName: '全部' })
      })
    },
    search() {
      var options = {
        appId: this.selectedApplication,
        mobile: this.mobile.trim(),
        channel: this.selectedChannel,
        method: this.selectedMethod,
        beginTime: this.dateFormattedBeginTime + 'T00:00:00',
        endTime: this.dateFormattedEndTime + 'T23:59:59',
        pageIndex: this.index,
        pageSize: this.pageSize,
      }

      callPost(
        'v1.0/sms/query',
        options,
        this.$refs.loading,
        this.$refs.confirm,
        'Searching'
      ).then((result) => {
        this.total = result.totalCount
        this.pages =
          result.totalCount <= 0
            ? 0
            : result.totalCount < this.pageSize
            ? 1
            : Math.ceil(result.totalCount / this.pageSize)
        this.list = result.items
      })
    },
    exportxlsx() {
      var options = {
        mobile: this.mobile.trim(),
        channel: this.selectedChannel,
        method: this.selectedMethod,
        beginTime: this.dateFormattedBeginTime + 'T00:00:00',
        endTime: this.dateFormattedEndTime + 'T23:59:59',
        pageIndex: 1,
        pageSize: 10000,
      }

      callPost(
        'v1.0/sms/query',
        options,
        this.$refs.loading,
        this.$refs.confirm,
        'Searching'
      ).then(async (result) => {
        if (result.totalCount > 10000) {
          this.$refs.confirm.show(
            'Exceed max 10000 record limits, please narrow search range.'
          )
          return
        }
        let excelContent = [
          {
            sendTime: '',
            mobile: '',
            channel: '',
            method: '',
            content: '',
            sendState: '',
            statusReportState: '',
          },
        ]

        if (result.totalCount > 0) {
          excelContent = result.items
        }

        const headers = [
          'sendTime',
          'mobile',
          'channel',
          'method',
          'content',
          'sendState',
          'statusReportState',
        ]

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('SMS')
        worksheet.columns = headers.map((key, index) => ({
          header: key,
          key,
          width: index === 4 ? 80 : 20,
        }))
        worksheet.addRows(excelContent)

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'Sms.xlsx'
        link.click()
        URL.revokeObjectURL(url)
      })
    },
    formatCreateTime(value) {
      return format(new Date(value), 'yyyy-MM-dd HH:mm')
    },
    formatChannel(value) {
      switch (value) {
        case '00':
          return '拜耳中国'
        case '01':
          return '拜耳医药'
        case '02':
          return '拜耳环境科学'
        case '03':
          return '拜耳作物科学'
        default:
          return ''
      }
    },
    formatMethod(value) {
      switch (value) {
        case 'notice':
          return '通知'
        case 'verification':
          return '验证码'
        case 'marketing':
          return '营销'
        default:
          return ''
      }
    },
    formatSmsContent(value) {
      if (!value) {
        return ''
      }
      if (value.length <= 20) {
        return value
      }
      return value.substr(0, 19) + '...'
    },
    viewSmsContent(value) {
      this.$refs.remind.show(value)
    },
  },
  created() {
    this.getapplication()
  },
}
</script>

<style>
.cardtable {
  margin-left: 40px;
  margin-right: 40px;
  padding: 10px;
  margin-top: 70px;
}

.empty {
  margin-top: 10px;
  font-size: 14px;
  color: #8e8c8c;
}

.pageinline {
  display: inline-block;
}

.totalrecord {
  padding-left: 50px;
}

::deep.v-date-picker-table .v-btn.v-btn--active{
  color: #8298f9 !important;
}
.successBtn{
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: white !important;
}
.warningBtn{
  background-color: #fb8c00 !important;
  border-color: #fb8c00 !important;
  color: white !important;
}
</style>
